module.exports = __webpack_public_path__ + "img/examine.ec08be66.png";